import { Component } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { forkJoin, Subscription, timer } from 'rxjs';
import { BookingGuest } from 'src/app/Models/booking-guest';
import { ResultStatus } from 'src/app/Models/common';
import { MenuItem } from 'src/app/Models/days-menu';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';
import { MealCard, SelectedMeal } from 'src/app/Models/selected-meal';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { BookingGuestsService } from 'src/app/Services/booking-guests.service';
import { CafeMenuNamesService } from 'src/app/Services/cafe-menu-names.service';
import { MealSelectionService } from 'src/app/Services/meal-selection.service';
import { TodayMenuService } from 'src/app/Services/todaymenu.service';
import { MealTimesService } from 'src/app/Services/meal-times.service';
import { Time } from '@angular/common';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { isAxAppWebView } from 'src/app/utils/is-ax-app-webview';

type MealTimes = {
 aiiActivityName: string;
 aiiActivityDesc: string;
 aiibegtime: Time;
 aiiendtime: Time;

 aiiLocationName: string;
 aiiDisplayLocationName: string;
 slnName: string;
 dplDeck: string;
 dpluid: Int16Array;
};
@Component({
 selector: 'app-meal-selection-page',
 templateUrl: './meal-selection-page.component.html',
 styleUrls: ['./meal-selection-page.component.css'],
})
export class MealSelectionPageComponent {
 evtCode: string | undefined;
 OBPortalSvcURL = '';

 MealtimesInfo: MealTimes[] | undefined;
 mealtimedata: any;
 dinnerstarttime: Time | undefined;
 dinnerendtime: Time | undefined;
 lunchstarttime: Time | undefined;
 lunchendtime: Time | undefined;
 lunchover: boolean = false;
 asofdate: string | undefined;
 mealSelections: UntypedFormGroup = new UntypedFormGroup({});
 previousMealSelections: UntypedFormGroup = new UntypedFormGroup({});
 firstLunchEntreeIndex: number = -1;
 lastLunchEntreeIndex: number = -1;
 firstDinnerAppIndex: number = -1;
 lastDinnerAppIndex: number = -1;
 firstDinnerEntreeIndex: number = -1;
 lastDinnerEntreeIndex: number = -1;

 userData?: UserData;
 shpid?: number;
 bookedGuests: BookingGuest[] = [];
 mealCards: MealCard[] = [];

 /** If true, shows the entire menu with no checkboxes */
 isEmployeeOrCrewMember: boolean = false;

 /** If true, all booked guests have opted out of lunch on the edit page. */
 currentMealCardsLunchOptOutCompletely: boolean = false;

 /** If true, at least one submitted meal card contains either a meal selection, a lunch opt out, or diet requirement */
 mealCardsContainSelections: boolean = false;
 /** If true, at least one submitted meal card has opted out of lunch */
 mealCardsContainLunchOptOut: boolean = false;
 /** If true, at least one submitted meal card has opted to have lunch ashore */
 mealCardsContainLunchAshore: boolean = false;
 /** If true, at least one submitted meal card has opted to have lunch at the ship's cafe */
 mealCardsContainLunchCafe: boolean = false;
 /** If true, at least one submitted meal card has diet requirements */
 mealCardsContainDietRequirements: boolean = false;

 menuItems: MenuItem[] = [];
 menuItemsFiltered: MenuItem[] = [];
 breakfastMenuItems: MenuItem[] = [];
 begDate?: Date | string;
 endDate?: Date | string;

 isLastDayOfCruise: boolean = false;
 isFirstDayOfCruise: boolean = false;
 cafeName: string = '';

 // displayedCutoffTime: string = '9:00 AM'
 displayedcutofftime: string = '9:00 AM';
 cutoffHour: number = 10;
 cutoffMinute: number = 0;
 isPastCuttoffWindow: boolean = false;
 cutoffTimerSubscription?: Subscription;

 /** If true, shows the entire menu for the day */
 viewEntireMenu: boolean = true;
 canViewMenu: boolean = false;
 mealSubmitButtonDisabled: boolean = true;
 LunchEntreeMenuItems: MenuItem[] = [];
 LunchDessertMenuItems: MenuItem[] = [];
 DinnerAppetizerMenuItems: MenuItem[] = [];
 DinnerEntreeMenuItems: MenuItem[] = [];
 DinnerDessertMenuItems: MenuItem[] = [];

 constructor(
 private appConfigService: AppConfigService,
 private todayMenuService: TodayMenuService,
 private bookingGuestsService: BookingGuestsService,
 private cafeMenuNamesService: CafeMenuNamesService,
 private mealSelectionService: MealSelectionService,
 private MealTimesService: MealTimesService,
 public dialog: MatDialog
 ) {
 try {
 this.displayedcutofftime =
 this.appConfigService.mealSelectionDisplayedCutoffTime;
 this.cutoffHour = this.appConfigService.mealSelectionCutoffHour;
 this.cutoffMinute = this.appConfigService.mealSelectionCutoffMinute;

 if (
 this.cutoffHour > 23 ||
 this.cutoffHour < 0 ||
 this.cutoffMinute > 59 ||
 this.cutoffHour < 0
 ) {
 throw new Error('Invalid cutoff time!');
 }

 // this.displayedCutoffTime = `${(this.cutoffHour > 12 ? this.cutoffHour - 12 : this.cutoffHour)}:${(this.cutoffMinute < 10 ? '0' + this.cutoffMinute : this.cutoffMinute)} ${(this.cutoffHour < 12 ? 'AM' : 'PM')}`;
 // this.displayedCutoffTime = `${(this.cutoffHour > 12 ? this.cutoffHour - 12 - 1 : this.cutoffHour - 1)}:${(this.cutoffMinute < 10 ? '0' + this.cutoffMinute : this.cutoffMinute)} ${(this.cutoffHour < 12 ? 'AM' : 'PM')}`;
 } catch {
 // this.displayedCutoffTime = '9:00 AM'
 this.displayedcutofftime = '9:00 AM';
 }
 }

 ngOnInit() {
 this.userData = JSON.parse(
 localStorage.getItem('userinfo') || '{}'
 ) as UserData;
 this.shpid = this.userData?.shipid!;
 this.begDate = this.userData?.pckgBeg;
 this.endDate = this.userData?.pckgEnd;

 this.initMealSelection();
 this.evtCode = cruiseContentEvtCodeFromSession(this.userData);

 this.asofdate = moment().format('YYYY-MM-DD');
 this.getMealTimes();
 }

 ngOnDestroy() {
 this.cutoffTimerSubscription?.unsubscribe();
 }

 initMealSelection(): void {
 forkJoin({
 todaysMenu: this.todayMenuService.getTodaysMenu(this.shpid),
 bookingGuests: this.bookingGuestsService.GetBookingGuests(
 this.userData?.rebuid!
 ),
 cafeMenuNames: this.cafeMenuNamesService.getCafeMenuNames(
 this.shpid,
 'Cafe'
 ),
 }).subscribe({
 next: (data) => {
 this.menuItems = data.todaysMenu.GetDaysMenu.DaysMenuList ?? [];
 this.isLastDayOfCruise = moment(this.menuItems[0]?.ilcdate).isSame(
 moment(this.endDate).format('YYYY-MM-DD')
 );
 this.isFirstDayOfCruise = moment(this.menuItems[0]?.ilcdate).isSame(
 moment(this.begDate).format('YYYY-MM-DD')
 );
 this.bookedGuests =
 data.bookingGuests.GetBookingGuests?.Result?.Status ===
 ResultStatus.Accepted
 ? data.bookingGuests.GetBookingGuests.BookingGuestList
 : [];
 this.cafeName =
 data.cafeMenuNames.GetCafeMenuNames?.Result?.Status ===
 ResultStatus.Accepted
 ? data.cafeMenuNames.GetCafeMenuNames.CafeMenuNamesList[0].slnName
 : '';

 //setup cutoff subscription if we're not past the cuttoff time yet
 const currentTime = moment();
 if (
 currentTime.isSameOrAfter(
 moment().hour(this.cutoffHour).minutes(this.cutoffMinute)
 )
 ) {
 this.cutoffTimeWindowHandler();
 } else {
 const diff =
 moment()
 .hour(this.cutoffHour)
 .minutes(this.cutoffMinute)
 .valueOf() - currentTime.valueOf();

 this.cutoffTimerSubscription = timer(diff).subscribe(() =>
 this.cutoffTimeWindowHandler()
 );
 }

 this.isEmployeeOrCrewMember = this.bookedGuests.length === 0;

 // get each guest's selected meals
 if (!this.isEmployeeOrCrewMember) {
 const folioIds = this.bookedGuests.map((g) => g.refFolfolioId);
 this.mealSelectionService
 .getSelectedMealsForGuests(
 folioIds,
 this.shpid,
 moment().format('YYYY-MM-DD')
 )
 .subscribe({
 next: (selectedMealsResponse) => {
 this.mealCards =
 selectedMealsResponse.mealCards.length > 0
 ? selectedMealsResponse.mealCards
 : [];
 this.mealCardsContainSelections = this.mealCards.some(
 (mc) =>
 mc.selectedMeals.length > 0 ||
 mc.mccLunchAshore ||
 mc.mccLunchCafe ||
 mc.mccText.length > 0
 );
 this.mealCardsContainLunchAshore = this.mealCards.some(
 (mc) => mc.mccLunchAshore
 );
 this.mealCardsContainLunchCafe = this.mealCards.some(
 (mc) => mc.mccLunchCafe
 );
 this.mealCardsContainLunchOptOut =
 this.mealCardsContainLunchAshore ||
 this.mealCardsContainLunchCafe;
 this.mealCardsContainDietRequirements = this.mealCards.some(
 (mc) => mc.mccText.length > 0
 );

 this.viewEntireMenu = !this.mealCardsContainSelections;
 this.setTodaysMenu();
 this.initMealSelectionForms();
 },
 });
 } else {
 this.setTodaysMenu();
 this.canViewMenu = true;
 }
 },
 });
 }

 setTodaysMenu(): void {
 this.breakfastMenuItems = this.menuItems.filter(
 (s) => s.mttName.includes('Breakfast') || s.mttName.includes('Eggs')
 );
 this.LunchEntreeMenuItems = this.menuItems.filter((s) =>
 s.mttName.includes('Lunch Entree')
 );
 this.LunchDessertMenuItems = this.menuItems.filter((s) =>
 s.mttName.includes('Lunch Dessert')
 );
 this.DinnerEntreeMenuItems = this.menuItems.filter((s) =>
 s.mttName.includes('Dinner Entree')
 );
 this.DinnerDessertMenuItems = this.menuItems.filter((s) =>
 s.mttName.includes('Dinner Dessert')
 );
 this.DinnerAppetizerMenuItems = this.menuItems.filter((s) =>
 s.mttName.includes('Dinner Appetizer')
 );

 // THE WHOLE MENU

 if (
 moment(this.menuItems[0]?.ilcdate).isSame(
 moment(this.begDate).format('YYYY-MM-DD')
 )
 ) {
 //remove all the breakfast items if it's the first date of the cruise

 this.menuItemsFiltered = this.menuItems.filter(
 (s) => s.mttName.includes('Lunch') || s.mttName.includes('Dinner')
 );
 } else if (this.isLastDayOfCruise) {
 //remove all the non breakfast items if it's the last day of the cruise

 this.menuItemsFiltered = this.breakfastMenuItems;
 }
 //keep all the items
 else {
 this.menuItemsFiltered = this.menuItems;
 }
 }

 // /**
 // * Called when the user clicks the 'View Selected Meals' button.
 // */
 // viewAllMenuOptionsHandler(): void {
 // this.viewEntireMenu = true;
 // this.setTodaysMenu();
 // }

 /**
 * Called when the user clicks the 'Show Selected Meals' button.
 */
 // viewOnlySelectedMealsHandler(): void {
 // this.viewEntireMenu = false;
 // this.setTodaysMenu();
 // }

 /**
 * Called when it's after the cutoff time (9:30 AM)
 */
 // cutoffTimeWindowHandler(): void {
 // this.isPastCuttoffWindow = true;
 // this.mealSelections.disable();
 // }
 cutoffTimeWindowHandler(): void {
 this.isPastCuttoffWindow = true;
 this.mealSelections.disable();
 }
 lunchOptOutHandler(): void {
 this.currentMealCardsLunchOptOutCompletely = this.bookedGuests.every(
 (_, i) => {
 return (
 (this.mealSelections.get(`${i}lunchAshore`)?.value as boolean) ===
 true ||
 (this.mealSelections.get(`${i}lunchCafe`)?.value as boolean) == true
 );
 }
 );
 }

 /**
 * Clears out all of the meal selection form controls, reinitializes the filtered menu as well as the form controls.
 */
 resetFilteredMenuAndForms(): void {
 this.mealSelections.controls = {};
 this.previousMealSelections.controls = {};
 this.setTodaysMenu();
 this.initMealSelectionForms();
 }

 initMealSelectionForms(): void {
 this.canViewMenu = false;
 this.mealSubmitButtonDisabled = true;
 //reset the form to pristine
 this.mealSelections.reset();
 this.firstLunchEntreeIndex = -1;
 this.lastLunchEntreeIndex = -1;
 this.firstDinnerAppIndex = -1;
 this.lastDinnerAppIndex = -1;
 this.firstDinnerEntreeIndex = -1;
 this.lastDinnerEntreeIndex = -1;

 //go through all the items and find the first indices for lunch and dinner entrees, as we need them for setting checkboxes
 //and initializing the controls for them
 this.menuItems.forEach((mi, index) => {
 switch (mi.mttName) {
 case 'Lunch Entree':
 this.firstLunchEntreeIndex =
 this.firstLunchEntreeIndex === -1
 ? index
 : this.firstLunchEntreeIndex;
 this.lastLunchEntreeIndex = index;
 break;
 case 'Dinner Appetizer':
 this.firstDinnerAppIndex =
 this.firstDinnerAppIndex === -1 ? index : this.firstDinnerAppIndex;
 this.lastDinnerAppIndex = index;
 break;
 case 'Dinner Entree':
 this.firstDinnerEntreeIndex =
 this.firstDinnerEntreeIndex === -1
 ? index
 : this.firstDinnerEntreeIndex;
 this.lastDinnerEntreeIndex = index;
 break;
 }
 });

 this.bookedGuests.forEach((guest, index) => {
 const mealCard = this.mealCards.find(
 (mc) => mc.mcdfoluid === guest.refFolfolioId
 );

 // add controls for individual meal selections as well as a half portion option for each lunch and dinner entree meal, all for each person
 // add controls for previousMealSelections as well, for displaying on the selected view
 if (this.firstLunchEntreeIndex !== -1) {
 const lunchAshore = mealCard?.mccLunchAshore ?? false;
 const lunchCafe = mealCard?.mccLunchCafe ?? false;

 this.mealSelections.addControl(
 `${index}lunchAshore`,
 new FormControl<boolean>(lunchAshore)
 );
 this.mealSelections.controls[
 `${index}lunchAshore`
 ].valueChanges.subscribe(() => this.lunchOptOutHandler());
 this.mealSelections.addControl(
 `${index}lunchCafe`,
 new FormControl<boolean>(lunchCafe)
 );
 this.mealSelections.controls[
 `${index}lunchCafe`
 ].valueChanges.subscribe(() => this.lunchOptOutHandler());

 this.previousMealSelections.addControl(
 `${index}lunchAshore`,
 new FormControl<boolean>(lunchAshore)
 );
 this.previousMealSelections.addControl(
 `${index}lunchCafe`,
 new FormControl<boolean>(lunchCafe)
 );

 for (
 let i = this.firstLunchEntreeIndex;
 i <= this.lastLunchEntreeIndex;
 i++
 ) {
 const mealIndex =
 mealCard?.selectedMeals.findIndex(
 (sm) => sm.mcdmicuid === this.menuItems[i].micuid
 ) ?? -1;
 const micuid = this.menuItems[i].micuid;
 const halfPortion =
 mealIndex !== -1
 ? mealCard?.selectedMeals[mealIndex].mcdHalfPortion ?? false
 : false;

 // show the buffet items but dont allow users to select them
 if (!this.menuItems[i].mttName.includes('Buffet')) {
 this.mealSelections.addControl(
 `${index}lunchEntree${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );
 this.mealSelections.addControl(
 `${index}lunchEntree${micuid}HalfPortion`,
 new FormControl<boolean>(halfPortion)
 );

 this.previousMealSelections.addControl(
 `${index}lunchEntree${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );
 this.previousMealSelections.addControl(
 `${index}lunchEntree${micuid}HalfPortion`,
 new FormControl<boolean>(halfPortion)
 );
 }
 }
 }

 if (this.firstDinnerAppIndex !== -1) {
 for (
 let i = this.firstDinnerAppIndex;
 i <= this.lastDinnerAppIndex;
 i++
 ) {
 const mealIndex =
 mealCard?.selectedMeals.findIndex(
 (sm) => sm.mcdmicuid === this.menuItems[i].micuid
 ) ?? -1;
 const micuid = this.menuItems[i].micuid;

 // show the buffet items but dont allow users to select them
 if (!this.menuItems[i].mttName.includes('Buffet')) {
 this.mealSelections.addControl(
 `${index}dinnerApp${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );

 this.previousMealSelections.addControl(
 `${index}dinnerApp${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );
 }
 }
 }

 if (this.firstDinnerEntreeIndex !== -1) {
 for (
 let i = this.firstDinnerEntreeIndex;
 i <= this.lastDinnerEntreeIndex;
 i++
 ) {
 const mealIndex =
 mealCard?.selectedMeals.findIndex(
 (sm) => sm.mcdmicuid === this.menuItems[i].micuid
 ) ?? -1;
 const micuid = this.menuItems[i].micuid;
 const halfPortion =
 mealIndex !== -1
 ? mealCard?.selectedMeals[mealIndex].mcdHalfPortion ?? false
 : false;

 // show the buffet items but dont allow users to select them
 if (!this.menuItems[i].mttName.includes('Buffet')) {
 this.mealSelections.addControl(
 `${index}dinnerEntree${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );
 this.mealSelections.addControl(
 `${index}dinnerEntree${micuid}HalfPortion`,
 new FormControl<boolean>(halfPortion ?? false)
 );

 this.previousMealSelections.addControl(
 `${index}dinnerEntree${micuid}`,
 new FormControl<boolean>(mealIndex !== -1)
 );
 this.previousMealSelections.addControl(
 `${index}dinnerEntree${micuid}HalfPortion`,
 new FormControl<boolean>(halfPortion)
 );
 }
 }
 }

 const hasDietRequirements = (mealCard?.mccText?.length ?? 0) > 0;
 this.mealSelections.addControl(
 `${index}dietRequirements`,
 new FormControl<boolean>(hasDietRequirements)
 );
 this.mealSelections.addControl(
 `${index}dietRequirementsComments`,
 new FormControl<string>(mealCard?.mccText ?? '')
 );

 this.previousMealSelections.addControl(
 `${index}dietRequirements`,
 new FormControl<boolean>(hasDietRequirements)
 );
 this.previousMealSelections.addControl(
 `${index}dietRequirementsComments`,
 new FormControl<string>(mealCard?.mccText ?? '')
 );
 });

 this.mealSubmitButtonDisabled = this.isPastCuttoffWindow;
 if (this.isPastCuttoffWindow) {
 this.mealSelections.disable();
 }
 this.previousMealSelections.disable();
 this.lunchOptOutHandler();
 this.canViewMenu = true;
 }

 submitMealSelectionsForm(): void {
 this.mealSubmitButtonDisabled = true;
 this.mealSelections.disable();

 const mealCardsToSubmit: MealCard[] = [];

 this.bookedGuests.forEach((guest, index) => {
 const mealCard: MealCard = {
 mcdfoluid: guest.refFolfolioId,
 ilcshpid: this.shpid as number,
 ilcDate: moment().format('YYYY-MM-DD'),
 mccLunchAshore: this.mealSelections.get(`${index}lunchAshore`)
 ?.value as boolean,
 mccLunchCafe: this.mealSelections.get(`${index}lunchCafe`)
 ?.value as boolean,
 mccText:
 this.mealSelections.get(`${index}dietRequirements`)?.value === true
 ? (this.mealSelections.get(`${index}dietRequirementsComments`)
 ?.value as string)
 : '',
 selectedMeals: [],
 };

 if (
 this.firstLunchEntreeIndex !== -1 &&
 !mealCard.mccLunchAshore &&
 !mealCard.mccLunchCafe
 ) {
 for (
 let i = this.firstLunchEntreeIndex;
 i <= this.lastLunchEntreeIndex;
 i++
 ) {
 const micuid = this.menuItems[i].micuid;

 const isSelected = this.mealSelections.get(
 `${index}lunchEntree${micuid}`
 )?.value as boolean;
 const isSelectedHalfPortion = this.mealSelections.get(
 `${index}lunchEntree${micuid}HalfPortion`
 )?.value as boolean;

 if (isSelected) {
 const selectedMeal: SelectedMeal = {
 mcdmicuid: this.menuItemsFiltered[i].micuid,
 mcdHalfPortion: isSelected && isSelectedHalfPortion,
 };
 mealCard.selectedMeals.push(selectedMeal);
 }
 }
 }

 if (this.firstDinnerAppIndex !== -1) {
 for (
 let i = this.firstDinnerAppIndex;
 i <= this.lastDinnerAppIndex;
 i++
 ) {
 const micuid = this.menuItems[i].micuid;

 const isSelected = this.mealSelections.get(
 `${index}dinnerApp${micuid}`
 )?.value as boolean;

 if (isSelected) {
 const selectedMeal: SelectedMeal = {
 mcdmicuid: this.menuItemsFiltered[i].micuid,
 mcdHalfPortion: false,
 };
 mealCard.selectedMeals.push(selectedMeal);
 }
 }
 }

 if (this.firstDinnerEntreeIndex !== -1) {
 for (
 let i = this.firstDinnerEntreeIndex;
 i <= this.lastDinnerEntreeIndex;
 i++
 ) {
 const micuid = this.menuItems[i].micuid;

 const isSelected = this.mealSelections.get(
 `${index}dinnerEntree${micuid}`
 )?.value as boolean;
 const isSelectedHalfPortion = this.mealSelections.get(
 `${index}dinnerEntree${micuid}HalfPortion`
 )?.value as boolean;

 if (isSelected) {
 const selectedMeal: SelectedMeal = {
 mcdmicuid: this.menuItemsFiltered[i].micuid,
 mcdHalfPortion: isSelected && isSelectedHalfPortion,
 };
 mealCard.selectedMeals.push(selectedMeal);
 }
 }
 }

 mealCardsToSubmit.push(mealCard);
 });

 this.mealSelectionService
 .saveSelectedMealsForGuests(mealCardsToSubmit)
 .subscribe({
 next: (selectedMealsResponse) => {
 this.mealCards =
 selectedMealsResponse.mealCards.length > 0
 ? selectedMealsResponse.mealCards
 : [];
 this.mealCardsContainSelections = this.mealCards.some(
 (mc) =>
 mc.selectedMeals.length > 0 ||
 mc.mccLunchAshore ||
 mc.mccLunchCafe ||
 mc.mccText.length > 0
 );
 this.mealCardsContainLunchAshore = this.mealCards.some(
 (mc) => mc.mccLunchAshore
 );
 this.mealCardsContainLunchCafe = this.mealCards.some(
 (mc) => mc.mccLunchCafe
 );
 this.mealCardsContainLunchOptOut =
 this.mealCardsContainLunchAshore || this.mealCardsContainLunchCafe;
 this.mealCardsContainDietRequirements = this.mealCards.some(
 (mc) => mc.mccText.length > 0
 );

 this.resetFilteredMenuAndForms();
 },
 complete: () => {
 document?.body
 ?.querySelector('.scrollingcontainer')
 ?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
 this.showalert('Thank you for submitting your meal selections.');
 },
 });
 }

 showalert(alerttext: string) {
 //alert(entertainmentitem.aiiActivityDesc);
 const dialogRef = this.dialog.open(AlertDialogComponent, {
 restoreFocus: false,
 panelClass: 'entertainerdialog',
 data: {
 alertMessage: alerttext,
 },
 });
 }

 getMealTimes() {
 this.mealtimedata = this.MealTimesService.getMealTimes(
 this.evtCode,
 this.asofdate
 ).subscribe((mealtimedata) => this.setMealTimes(mealtimedata));
 }

 setMealTimes(resdata: any) {
 this.mealtimedata = resdata;
 if (this.mealtimedata.GetMealTimes.Result.Status == 'A') {
 this.MealtimesInfo = this.mealtimedata.GetMealTimes.MealTimeList;
 for (let i = 0; i <= this.MealtimesInfo!.length; i++) {
 if (this.MealtimesInfo![i].aiiActivityName.includes('Dinner')) {
 this.dinnerstarttime = this.MealtimesInfo![i].aiibegtime;
 this.dinnerendtime = this.MealtimesInfo![i].aiiendtime;
 }
 if (this.MealtimesInfo![i].aiiActivityName.includes('Lunch')) {
 this.lunchstarttime = this.MealtimesInfo![i].aiibegtime;
 this.lunchendtime = this.MealtimesInfo![i].aiiendtime;
 const now = moment();
 const timeMoment = moment(this.lunchendtime, 'HH:mm:ss');

 const nowAligned = moment()
 .hours(now.hours())
 .minutes(now.minutes())
 .seconds(now.seconds())
 .milliseconds(now.milliseconds());
 const timeAligned = moment()
 .hours(timeMoment.hours())
 .minutes(timeMoment.minutes())
 .seconds(timeMoment.seconds())
 .milliseconds(timeMoment.milliseconds());

 this.lunchover = nowAligned.isAfter(timeAligned);
 }
 }
 }
 }

scrollDietTextareaIntoView(event: FocusEvent): void {
 const textarea = event.target as HTMLElement | null;
 if (!textarea) {
 return;
 }

 setTimeout(() => {
 const container = document.querySelector(
 '.scrollingcontainer.meal-page-scroll'
 ) as HTMLElement | null;
 const useDocumentScroll =
 document.body.classList.contains('ios-touch-scroll');
 const headerOffset = 80;
 const bottomReserve = 120;
 const textareaRect = textarea.getBoundingClientRect();

 if (useDocumentScroll) {
 const viewport = window.visualViewport;
 const visibleHeight = viewport?.height ?? window.innerHeight;
 const visibleBottom = visibleHeight - bottomReserve;

 if (
 textareaRect.bottom > visibleBottom ||
 textareaRect.top < headerOffset
 ) {
 const scrollTarget =
 window.scrollY + textareaRect.top - headerOffset;
 window.scrollTo({
 top: Math.max(0, scrollTarget),
 behavior: 'auto',
 });
 }
 return;
 }

 if (!container) {
 return;
 }

 const containerRect = container.getBoundingClientRect();
 const scrollDelta = textareaRect.top - containerRect.top - headerOffset;

 if (Math.abs(scrollDelta) > 5) {
 container.scrollTop += scrollDelta;
 }
 }, 300);
 }

 setDietTextareaKeyboardState(open: boolean): void {
 document.documentElement.classList.toggle('keyboard-open', open);
 document.body.classList.toggle('keyboard-open', open);
 }

 onDietTextareaFocus(event: FocusEvent): void {
 this.setDietTextareaKeyboardState(true);
 this.scrollDietTextareaIntoView(event);
 }

 onDietTextareaBlur(): void {
 window.setTimeout(() => {
 const activeElement = document.activeElement;
 const stillEditingDietTextarea =
 activeElement instanceof HTMLTextAreaElement &&
 activeElement.classList.contains('diet-restrictions-textarea');

 if (!stillEditingDietTextarea) {
 this.setDietTextareaKeyboardState(false);
 }
 }, 100);
 }
}
